import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import { TreeNode } from 'primeng/api'
import { TranslocoRootModule } from '../../../../../../transloco-root.module'
import { TreeSelectModule } from 'primeng/treeselect'
import { Observable } from 'rxjs'
import { ClientIPTreeNode } from '../../../client-ip-list/types/ClientIPListTree'
import { ClientIpListService } from '../../../client-ip-list/services/client-ip-list/client-ip-list.service'
import { AsyncPipe } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { FloatLabel } from 'primeng/floatlabel'

@Component({
  selector: 'app-multiple-ip-entries-tree',
  standalone: true,
  imports: [TreeSelectModule, TranslocoRootModule, AsyncPipe, IonicModule, FloatLabel, FormsModule],
  templateUrl: './multiple-ip-entries-tree.component.html',
  styleUrl: './multiple-ip-entries-tree.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultipleIPEntriesTreeComponent),
      multi: true,
    },
  ],
})
export class MultipleIPEntriesTreeComponent implements OnInit, ControlValueAccessor {
  @Input() clientId: number
  @Output() selectedTreeNode = new EventEmitter<any>()

  private clientIpListService = inject(ClientIpListService)
  protected selectedItem: TreeNode[] = []
  protected treeNodes$: Observable<ClientIPTreeNode[]>

  private onChange: (value: any) => void = () => {}
  private onTouched: () => void = () => {}

  ngOnInit(): void {
    this.treeNodes$ = this.clientIpListService.getFilteredTreeNodes(this.clientId)
  }

  writeValue(value: TreeNode[] | null): void {
    this.selectedItem = value ?? []
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  onSelectedChange(value: TreeNode[]) {
    this.selectedItem = value
    this.onChange(value)
    this.onTouched()
    this.selectedTreeNode.emit(this.selectedItem.map((n) => n.data))
  }
}
